import { render, staticRenderFns } from "./BookmarkButton.vue?vue&type=template&id=1c2359c9&scoped=true&"
import script from "./BookmarkButton.vue?vue&type=script&lang=ts&"
export * from "./BookmarkButton.vue?vue&type=script&lang=ts&"
import style0 from "./BookmarkButton.vue?vue&type=style&index=0&id=1c2359c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2359c9",
  null
  
)

export default component.exports